'use client';

import * as React from 'react';
import * as ProgressPrimitive from '@radix-ui/react-progress';

import { cn } from '@/src/shared/lib/shadcn';

const DEFAULT_MAX = 100;

/** Radix logs an error for a value outside [0, max]; callers pass raw percentages, so the bar clamps. */
function clampValue(value: number, max: number) {
  if (!Number.isFinite(value)) return 0;
  return Math.min(max, Math.max(0, value));
}

function Progress({
  className,
  value,
  max = DEFAULT_MAX,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root>) {
  const clamped = typeof value === 'number' ? clampValue(value, max) : value;
  return (
    <ProgressPrimitive.Root
      data-slot="progress"
      value={clamped}
      max={max}
      className={cn('bg-primary/20 relative h-2 w-full overflow-hidden rounded-full', className)}
      {...props}
    >
      <ProgressPrimitive.Indicator
        data-slot="progress-indicator"
        className="bg-primary h-full w-full flex-1 transition-all"
        style={{ transform: `translateX(-${100 - ((clamped || 0) / max) * 100}%)` }}
      />
    </ProgressPrimitive.Root>
  );
}

export { Progress };
